import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { mdiBellOutline, mdiBellRingOutline } from '@mdi/js'
import { AppIcon } from '../ui/icon'
import { Button } from '../ui/button'
import { useBrowserNotifications } from '../../hooks/useBrowserNotifications'

export function BrowserNotificationsToggle({
    className,
    size = 'default',
}: {
    className?: string
    /** `default` in a page header (patterns §5); `sm` in a compact bar. */
    size?: 'default' | 'sm'
}) {
    const { t } = useTranslation('conversations')
    const { supported, permission, enabled, toggle } = useBrowserNotifications()
    const [refused, setRefused] = useState(false)

    if (!supported) return null

    if (permission === 'denied' || (refused && permission !== 'granted')) {
        return (
            <p
                className="max-w-[22rem] text-xs text-muted-foreground"
                data-testid="browser-notifications-blocked"
            >
                {t('notifications.blocked')}
            </p>
        )
    }

    const label = enabled ? t('notifications.on') : t('notifications.enable')

    return (
        <Button
            type="button"
            variant="outline"
            size={size}
            aria-pressed={enabled}
            aria-label={label}
            title={label}
            className={className}
            onClick={() => {
                void toggle().then((granted) => {
                    setRefused(!granted && permission !== 'granted')
                })
            }}
            data-testid="browser-notifications-toggle"
        >
            <AppIcon path={enabled ? mdiBellRingOutline : mdiBellOutline} size="xs" className="md:mr-1" />
            <span className="hidden md:inline">{t('notifications.enable')}</span>
        </Button>
    )
}
